export enum EFundingRequestWorkerName {
  VTB_LOAN = 'VTB_LOAN',
}
